import { media, styled } from '@styles';
import { css } from 'styled-components';

export const Wrapper = styled.form``;

export const TabList = styled.div`
  display: none;
  ${media.smMediumScreen`
    display: flex;
    width: 100%;
    padding-bottom: 16px;
    border-bottom: 1px solid #2c2c2c1a;
    overflow-x: auto;
    overflow: hidden;
    scroll-behavior: smooth;

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
    }
    &::-webkit-scrollbar {
      height: 2px;
      background-color: rgba(44, 44, 44, 0.25);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(44, 44, 44, 0.25);
    }
  `}
  ${media.smallScreen`
    padding-bottom: 10px;
  `}
`;

export const Tab = styled.div<{ active: boolean }>`
  ${({ active, theme }) => css`
    font-family: ${theme.typography.baseFontFamily};
    font-size: ${theme.typography.baseFontSize};
    line-height: ${theme.typography.baseFontSize};
    margin: 0 15px;
    color: #000000;
    outline: none;
    opacity: ${active ? 1 : 0.3};
    white-space: nowrap;
    flex-shrink: 0;
    &:first-of-type {
      margin-left: 0;
    }
    &:last-of-type {
      margin-right: 0;
    }
    ${active &&
    css`
      ${media.smMediumScreen`
        position: relative;
        &:after {
          content: '';
          position: absolute;
          height: 2px;
          left: 0;
          right: 0;
          bottom: -6px;
          background-color: red;
        }
      `}
      ${media.smallScreen`
        &:after {
          bottom: -8px;
        }
      `}
    `};
  `}
`;

export const TabContent = styled.div`
  height: 100%;
`;

export const Item = styled.div<{ hide: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.smMediumScreen`
    display: ${({ hide }) => (hide ? 'none' : 'flex')};
    padding-top: 10px;
    overflow-x: auto;
  `}
  &:not(:last-child) {
    margin-bottom: 20px;
    ${media.xLargeScreen`
      margin-bottom: 18px;
    `}
    ${media.largeScreen`
      margin-bottom: 12px;
    `}
    ${media.smMediumScreen`
      margin-bottom: 0;
    `}
  }
`;

export const Name = styled.div`
  opacity: 0.5;
  white-space: nowrap;
  margin-right: 30px;
  font-size: ${(props) => props.theme.typography.smallFontSize};
  ${media.xLargeScreen`
    margin-right: 20px;
  `}
  ${media.smMediumScreen`
    display: none;
  `}
`;
